import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { Angulartics2Module } from 'angulartics2';
import { AuthorizationModule } from '../authorization/authorization.module';
import { FeatureFlagsModule } from '../core/feature-flags/feature-flags.module';
import { HomeItemComponent } from './home-item/home-item.component';
import { HomeRoutingModule } from './home.routing.module';
import { FeatureHeroService } from './home/feature-hero.service';
import { HomeComponent } from './home/home.component';
import { PromotionalHeroComponent } from './promotional-hero/promotional-hero.component';

@NgModule({
  declarations: [HomeComponent, PromotionalHeroComponent, HomeItemComponent],
  imports: [CommonModule, HomeRoutingModule, FeatureFlagsModule, Angulartics2Module, AuthorizationModule],
  providers: [FeatureHeroService],
})
export class HomeModule {}
